<script setup>
import {defineComponent} from "vue";
import {useRoute, useRouter} from "vue-router";

defineComponent({name: 'PlatFormLayout'})
const router = useRouter()
    , route = useRoute()
</script>

<template>
  <div class="pg_body">
    <ul class="tab_st02">
      <li :class="{'on': route.name === 'PlatformCloud'}">
        <a @click="router.push('/platform/cloud')">클라우드 자원</a>
      </li>
      <li :class="{'on': route.name === 'PlatformStudio'}">
        <a @click="router.push('/platform/studio')">회의실 • 스튜디오</a>
      </li>
      <li :class="{'on': route.name === 'PlatformEquip'}">
        <a @click="router.push('/platform/equip')">시설 • 장비</a>
      </li>
      <li :class="{'on': route.name === 'PlatformConsult'}">
        <a @click="router.push('/platform/consult')">컨설팅 • 자문</a>
      </li>
    </ul>
    <router-view/>
  </div>
</template>

<style scoped>
.tab_st02{
  padding: 20px;
}
</style>
